// extracted by mini-css-extract-plugin
module.exports = {"hint__icon-box":"hint__icon-box--f3cea8","hint__iconBox":"hint__icon-box--f3cea8","hint__icon":"hint__icon--b2be2a"};